import { useState, useEffect } from "react";
import { notify, ProposalDateDiff, myDateFormat, dateFormat2 } from "../../../utils/utils";
import services from '../../../services/index'
import {
  useAuthContext,
  useCartContext,
  useProductsContext,
  useWishlistContext,
} from "../../contexts";
import { useLocation, useNavigate } from "react-router";
import commonObj from '../../../utils/Common';


const AddProposal = ({ product, sessionId, closeHandler, prcount, isViewDate, refId, imgurl}) => {
const { token, userInfo } = useAuthContext();  
//const { isInCart } = useProductsContext();
const {addProductToCart, disableCart} = useCartContext()
const navigate = useNavigate();
const location = useLocation();

const [isDisabled, setIsDisabled] = useState(false)
const [proposalData, setProposalData] = useState([])
const [proposLimit, setProposLimit] = useState(0)
const [accepted, setAccepted] = useState(false)
const [isShow, setIsShow] = useState(false)
const [firstFromId, setFirstFromId] = useState(0)
const [priceError, setPriceError] = useState('')



var ProposalDate;

const [newProposal, setNewProposal] = useState(
    {
        productId: product.id,
        fromId: sessionId,
        praposalPrice: "",
        refId:0,
        productAddedBy:product.addBy,
        }
  );
  //let inCart = isInCart(product.id);

  
  useEffect(() => { 
   
    getProposalList()
   console.log(product) ;
  }, [])
    
  async function getProposalList(){
    let filter = {productId:product.id,fromId: sessionId}
    if(refId) filter['refId'] = refId
    const resData = await services.proposalService.getProposal(filter)
    if(resData?.status===1){
      if(resData?.data?.result?.length>0){
        setAccepted(true)
         ProposalDate = ProposalDateDiff(resData?.data?.result[0]?.createdAt)
         if(ProposalDate){
            setNewProposal({ ...newProposal, refId: resData?.data?.result[0]?.refId })

         let i = 0;
         (resData?.data?.result).map( (c, index) => 
         { 
           if(c.fromId===sessionId){ 
            ++i;
           }
           //if(c.isAccepted!==null) setAccepted(true)
           if(index===0) setFirstFromId(c.fromId)
           if(resData?.data?.result?.length === (index+1) && c.isAccepted==='2') { setAccepted(false) }

          }
          )
          console.log(i)
          setProposLimit(i) 
        }
        
        }
      setProposalData(resData?.data?.result)
      setIsShow(true)
    }
    }
  const submitHandler = async (e) => {
    e.preventDefault();
    setIsDisabled(true)
    //const validation = validatePriceRange(newProposal.praposalPrice)
    /*if (!validation.ok) {
      notify("error", commonObj.getLabel('Invalid_price') || 'Invalid price')
      setIsDisabled(false)
      return
    }*/
   // console.log(newProposal);return false;
    const proposalRes = await services.proposalService.addProposal([newProposal]);
    if (proposalRes.status === 1) {
        notify("success", commonObj.getLabel('Proposal_sent'));
        prcount(1)
        closeHandler(false)

        let notifUserId = 0;
        if(sessionId===newProposal.productAddedBy) notifUserId = firstFromId || newProposal.fromId
        else if(sessionId===newProposal.fromId) notifUserId = newProposal.productAddedBy
        await services.notificationService.saveNotification( {moduleId:2,moduleType:'addPraposal', userId:notifUserId, messageData:`You got a new praposal of amount ${newProposal.praposalPrice} for the product "${product?.productName}"`} )

    }
    setIsDisabled(false)
    

  };

 const handleBuy = async (e,data) => { 
  e.preventDefault();
  if (!token) {
    navigate("/login", { state: { from: location.pathname } });
    notify("warn", commonObj.getLabel('Please_Login_to_continue'));
  } else { 
      if(product?.productrefType==4){ 
        copyProduct(product, data)
      }else{ //console.log('sss',product);
      addProductToCart(product, imgurl, data.praposalPrice, data.id);
      setTimeout(() => {
        navigate("/cart");
      }, 100);
      }
      
  }
 }

async function copyProduct(product,data){
  let copyProductObj = {
    productName: product.productName,
    productDescription: product.productDescription,
    productCategory: product.productCategory,
    productShortDescription: product.productShortDescription,
    productQuantity: product.productQuantity,
    productPrice: data.praposalPrice,
    productCrossPrice: data.praposalPrice*product.productQuantity,
    productSku: product.productSku,
    productImage: product.productImage,
    fromWhere: product.fromWhere,
    fromWhen: product.fromWhen,
    productionMethod: product.productionMethod,
    productrefType: 5,
    productSubCategory: product.productSubCategory,
    status: 0,
    copyId:product.id,
    addBy:data.fromId,
  }
  let proposalRes = await services.productService.CheckProduct(copyProductObj);
  //console.log(proposalRes?.data?.product);
  if (proposalRes?.status === 1) {
    addProductToCart(proposalRes?.data?.product, imgurl, data.praposalPrice, '');
      setTimeout(() => {
        navigate("/cart");
      }, 100)
  }else{
    //notify("error",'');
  }
  //console.log(data, product,'ddd')
} 

 const ChangeProposalStatus = async (id, type) => {
  let proposalRes = await services.proposalService.changeStatus({id:id, type:type});
  if (proposalRes.status === 1) {
    getProposalList()
    let notifUserId = 0;
    if(sessionId===newProposal.productAddedBy) notifUserId = firstFromId || newProposal.fromId
    else if(sessionId===newProposal.fromId) notifUserId = newProposal.productAddedBy

    let pt = 'Pending'
    if(type===1){
      setAccepted(true) 
      pt = 'Accepted'
      notify("success", commonObj.getLabel('Proposal_Accepted'));
    }else if(type===2){
      setAccepted(false)
      pt = 'Re-proposed'
      notify("success", commonObj.getLabel('Proposal_is_Re_proposed'));
    }else{
      setAccepted(true)
      pt = 'Rejected'
      notify("warn", commonObj.getLabel('Proposal_Rejected'));
    }
    await services.notificationService.saveNotification( {moduleId:2,moduleType:'praposalAction', userId:notifUserId, messageData:`Proposal for the product "${product?.productName}" is ${pt} `} )

    return true
  }
 }

 const handleAcceptAction = (isAccepted) => {
   let x = '';
    switch(isAccepted){
      case '1': 
      x = 'Accepted'
      break;
      case '0' : 
      x = 'Rejected'
      break;
      case '2' : 
      x = 'Re-proposed'
      break;
      default : 
      x = 'Pending'
    }

    return x;
 }

 const validatePriceRange = (price) => {
        setPriceError('')
        const min = Number(product?.category?.minPrice);
        const max = Number(product?.category?.maxPrice);
      
        // if no range from API, do nothing
        if (!min && !max) return true;
        if (price === '' || price == null) return true;
      
        if (min && price < min) {
          setPriceError(`${commonObj.getLabel('Price_Low')} ${min} ${commonObj.getCurrency('mn')}`)
          return { ok: false, reason: 'too_low', min, max }
        }
      
        if (max && price > max) {
          setPriceError(`${commonObj.getLabel('Price_High')} ${max} ${commonObj.getCurrency('mn')}`)  
          return { ok: false, reason: 'too_high', min, max }
        }
      
        setPriceError('')
        return { ok: true, min, max }
  };

  

  return (
    <>
    { isShow ? (
    <div>
      <div className="flex p-2 px-4 bg-green-500 justify-between shrink-1 items-center">
        <div className="flex flex-col text-center items-center">
          <label className="text-md text-white uppercase leading-normal">{commonObj.getLabel('Product_Name')}</label>
          <div className="text-md text-yellow-400 leading-normal font-bold mt-2">{product?.productName}</div>
        </div>
        <div className="flex flex-col text-center items-center">
        <label className="text-md text-white uppercase leading-normal"> {commonObj.getLabel('Quantity')}</label>
        <div className="text-md text-yellow-400 leading-normal font-bold mt-2"> {product?.productQuantity}</div>
        </div>
        <div className="flex flex-col text-center items-center">
          <label className="text-md text-white uppercase leading-normal">{commonObj.getLabel('Price')}</label>
          <div className="text-md text-yellow-400 leading-normal font-bold mt-2"> {commonObj.getCurrency('mn')}{product?.productPrice} </div>
        </div>
      </div>
      { proposalData && proposalData.map((data, index)=>(
       
       <div newnode={data.id} className="cheat-box border-b border-solid border-slate-200 pt-2">
        <div className={`i my-4 py-2 px-6 rounded-t ${data.fromId===sessionId ? 'buyer_right' : 'seller_left'}`}>
          
          <div className={`flex-none row-reverse-text flex flex-row justify-between  `}>
          <p className="block text-sm">
            {data.fromId!==sessionId ? data.user.firstName+' '+data.user.lastName : 'Me'}
          </p>
          
          { !isViewDate && data.fromId!==sessionId && data.isAccepted===null && (proposalData.length === (index+1)) && 
         
         
         <div className="accept_reject flex flex-row">
            <a href="#" onClick={()=>ChangeProposalStatus(data.id,1)} className="px-2 text-xs  text-green-500  dark:text-green-500">Accept</a>
            <a href="#" onClick={()=>ChangeProposalStatus(data.id,0)} className=" px-2 text-xs  text-red-500  dark:text-red-500">Reject</a>
            <a href="#" onClick={()=>ChangeProposalStatus(data.id,2)} className=" px-2 text-xs  text-red-500  dark:text-red-500">Re-Propose</a>
          </div> }

          </div>


          <div className="flex-1 bg-green-200 text-black p-2 mt-1 mx-4 rounded-md mb-2 relative cheat-bar">
            <div className="flex items-center justify-between"> {commonObj.getCurrency('mn')}{data.praposalPrice} / kg <>&nbsp;</> <span class="pl-4 inline-flex items-baseline text-xs text-gray-500  dark:text-gray-400">{dateFormat2(data.createdAt, true)}</span></div>
            <div className={`absolute ${data.fromId===sessionId ? 'right-1' : 'left-1'} top-2 z-50  translate-x-1/2 rotate-45 w-2 h-2 aroow-icon`}></div>

          </div>
          
          <div>
            {data.isAccepted==='1' && !isViewDate && userInfo?.userType===4 &&
              <a onClick={(e) => handleBuy(e,data)} class="rounded-sm relative px-2 text-xs text-center bg-green-500 text-white hover:bg-green-600 py-1 cursor-pointer">{commonObj.getLabel('Buy Now')}</a>
            }
            { (proposalData.length === (index+1)) && 
            <span className=" px-2 text-xs  text-blue-500  dark:text-blue-500">{commonObj.getLabel('Above_proposal_is')} {handleAcceptAction(data.isAccepted)}</span> }
          
          </div>
        </div>        
       
</div>
      ))}

      { !isViewDate && !accepted && 
    <form
      action=""
      className="flex flex-col gap-3 p-5 border-b border-solid border-slate-200 rounded-t"
      onSubmit={submitHandler}
    >
   

    
      <div className="flex flex-wrap w-full">
      
        <label for="hs-trailing-button-add-on" className="sr-only w-full">
          {commonObj.getLabel('Proposed_Price')}
        </label>
        <div className="flex rounded-lg w-full">
        <input
            required
            type="number"
            min="0"
            name="hs-trailing-button-add-on"
            className="py-3 px-4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={(e) =>
                setNewProposal({ ...newProposal, praposalPrice: e.target.value })
            }
            value={newProposal.praposalPrice}
          />
     
     {proposLimit < 3 ? (
     <button
       type="submit"
       className="py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold  border border-slate-500 rounded-r-lg  bg-green-500 text-white hover:bg-green-600 "
       disabled={isDisabled}
     >
       {commonObj.getLabel('Submit')}
     </button>
     ): commonObj.getLabel('Limit_Exceeded')}

      </div>

      {/* inline validation / allowed range note 
      <div className="w-full mt-2 text-xs">
                  <div className="text-gray-600 dark:text-gray-300">
                    {commonObj.getLabel('Allowed_Price_Aange') || 'Allowed range'}: {commonObj.getCurrency('mn')}{product?.category?.minPrice} — {commonObj.getCurrency('mn')}{product?.category?.maxPrice}
                  </div>
                  {priceError && <div className="text-sm text-red-600 mt-1">{priceError}</div>}
                </div>*/}
      </div>
 
    </form>
    }
    </div> 
    ) : (<div class="flex items-start justify-between p-2 "> {commonObj.getLabel('Loading')} </div>)
    }
    </>
  );
};

export default AddProposal;
